import { useContext } from 'react';
import { RouteContext } from '../../components/RouteContext';
/**
 * Returns the routes of the current app.
 */
export function useRoutes() {
    return useContext(RouteContext).routes;
}
//# sourceMappingURL=useRoutes.js.map